import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { cached, tracked } from '@glimmer/tracking';

import type { Service } from 'webapp-types';

import type { Metric } from 'webapp/models-custom';

export interface Args {
	model: Metric;
	isStatusHidden?: boolean;
	trackingOriginForAdd?: string;
	buttonText?: string;
}

export default class MetricLibraryGridItemBaseComponent<T extends Args> extends Component<T> {
	@service('account') declare accountService: Service.Account;
	@service('current-user') declare currentUserService: Service.CurrentUser;
	@service('model-manager/metrics')
	declare mmMetricsService: Service.ModelManager.Metrics;

	@tracked isLoading = false;

	origin = 'allmetrics';

	get model(): Metric {
		return this.args.model;
	}

	get metricName() {
		return this.model.name;
	}

	get source() {
		return this.model.source;
	}

	@cached
	get sourceType() {
		return this.model.sourceType;
	}

	get sourceAvatar() {
		return this.model.sourceAvatar;
	}

	get sourceTitle() {
		return this.model.sourceName;
	}

	get trackingOriginForAdd() {
		return this.args.trackingOriginForAdd || this.origin;
	}

	get isDisabled() {
		return this.model.isUsageDisabled;
	}

	get canAddToHome(): boolean {
		return this.currentUserService.hasHome;
	}

	get isOverlayShown() {
		return !this.isDisabled && this.canAddToHome;
	}

	get isActionDenied() {
		return this.accountService.handleDemo() || this.isLoading || this.isDisabled;
	}

	get buttonText() {
		return this.args.buttonText || 'Add to Home';
	}

	@action
	createNew() {
		if (this.isActionDenied) {
			return;
		}

		this.isLoading = true;

		void this.mmMetricsService.addMetricsToHome([this.model]).finally(() => {
			this.isLoading = false;
		});
	}
}
